export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_CLIENT_ID,
  callbackUrl: process.env.REACT_APP_CALLBACK_URL,
  realm: process.env.REACT_APP_AUTH_REALM
}
